import { z } from "zod";

/**
 * ListNodeSchema - Content Schema for List Node
 *
 * List nodes are block-level containers for list items.
 * Supports bullet, numbered, and checkbox lists.
 *
 * Nesting constraints:
 * - ✅ children can ONLY contain: ListItemNode
 * - ❌ Does NOT allow: any other node type
 */
export const ListNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("list"),
  version: z.literal(1),
  key: z.string(),

  // Business data
  listType: z.enum(["bullet", "number", "check"]), // List type
  start: z.number().optional(), // Start index for numbered lists (1-based)
  children: z.array(z.any()), // Array of ListItemNode children
}).strict();

export type ListNode = z.infer<typeof ListNodeSchema>;
